import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "../src/assets/css/main.css";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import VueCarousel from "vue-carousel";
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import * as rules from 'vee-validate/dist/rules';
import Vuelidate from 'vuelidate';
import VueBootstrapToasts from "vue-bootstrap-toasts";
import VueSweetalert2 from 'vue-sweetalert2';
import vueAwesomeCountdown from 'vue-awesome-countdown'
import VueEllipseProgress from 'vue-ellipse-progress';

Vue.config.productionTip = false;

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
})
localize('en', en);

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.use(Vuelidate);
Vue.use(VueCarousel);
Vue.use(BootstrapVueIcons);
Vue.use(BootstrapVue);
Vue.use(VueBootstrapToasts);
Vue.use(VueSweetalert2);
Vue.use(vueAwesomeCountdown, 'vac')
Vue.use(VueEllipseProgress);


new Vue({
  router,
  store,
  beforeMount() {
    if (store.state.logindate == null) {
      store.commit('logout');
    } else {
      const d = new Date(store.state.logindate);
      const d1 = new Date();
      const diff = (d1 - d) / (1000 * 60 * 60 * 24);
      if (diff > 1) {
        store.commit('logout');
      }
    }
  },
  render: (h) => h(App),
}).$mount("#app");
